module.exports = __webpack_public_path__ + "static/media/7.d4855e58.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/Tutorial/screenshots/Managing/7.jpg
// module id = 1643
// module chunks = 0